import {LOAD_SETTINGS, SET_CURRENT, SETTINGS} from "../type";

export const loadSettings = (offset, limit, setPage=null, setPageSize=null, options=null, reload=null, orders) => dispatch => {
    // dispatch({type: SET_CURRENT, payload: {current: SETTINGS, searchTable: SETTINGS, currentUrl: "/index/settings"}})
    dispatch({type: LOAD_SETTINGS, payload: {}})

}